// extracted by mini-css-extract-plugin
export var container = "HeaderLogo-module--container--Ta4dO";
export var logo = "HeaderLogo-module--logo--kNaDp";
export var logo_text_div = "HeaderLogo-module--logo_text_div--3EMgH";
export var logo_text = "HeaderLogo-module--logo_text--2OZkN";